import React, { useState } from 'react'
import './DeleteCareerContainer.scss';
import { deleteCareer } from '../../data/api';
import { Bounce, ToastContainer, toast } from 'react-toastify';


export const DeleteCareerContainer = ({toggleDeleteCareer, career}) => {

    const handleSubmit = async (event) => {

        const resp = await deleteCareer(career._id)
        if(resp.status === 'success'){
            toast.success('¡Carrera Eliminada!', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
                });

            // Recargar la página después de 1 segundo
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else{
            toast.error(resp.error, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
                });
        }
    }

    const toggle = () => {
        toggleDeleteCareer(null)
    }

    return (
        <div className='delete-career-background'>
            <div className='delete-career-container'>
                <h3>¿Estás seguro/a que quieres eliminar la carrera "{career.name}"?</h3>
                <div className='delete-career-hr'></div>
                <button className="btn-delete" onClick={handleSubmit}>Eliminar carrera</button>
                <button className='btn-cancel' onClick={toggle}>Cancelar</button>
            </div>
            <ToastContainer />
        </div>
    )
}
